import { useCallback } from 'react'
import { withFilterParams } from '../../../../../components/AgGrid/columnDefs'
import { useTranslation } from 'react-i18next'
import { RecipientsGridQuery } from '../queries'

export const useRecipientsGrid = (letterId) => {
  const { t } = useTranslation()

  const getParams = useCallback(
    (currentService) => {
      const valueGetter = (params) => {
        const field = params.column.getColDef().field
        const colId = params.column.getColDef().colId
        const search = colId || field
        switch (search) {
          default:
            return params.value
        }
      }
      const LetterColumnDefs = [
        {
          headerName: t('UNIQUE REF.'),
          colId: 'uniqueReference',
          field: 'uniqueReference',
          width: 70,
          sortable: true,
          ...withFilterParams,
        },
        {
          headerName: t('FIRST NAME'),
          field: 'firstname',
          width: 80,
          sortable: true,
          ...withFilterParams,
        },
        {
          headerName: t('LAST NAME'),
          field: 'lastname',
          width: 80,
          sortable: true,
          ...withFilterParams,
        },
        {
          headerName: t('STREET'),
          field: 'street',
          width: 120,
          sortable: true,
          ...withFilterParams,
        },
        {
          headerName: t('STREET NR.'),
          field: 'streetNumber',
          width: 60,
          sortable: true,
          ...withFilterParams,
        },
        {
          headerName: t('ZIP'),
          field: 'zip',
          width: 80,
          sortable: true,
          ...withFilterParams,
        },
        {
          headerName: t('CITY'),
          field: 'city',
          width: 80,
          sortable: true,
          ...withFilterParams,
        },
      ]
      const LettersCustomFilter = []
      return {
        query: RecipientsGridQuery,
        columnDefs: LetterColumnDefs,
        customFilters: LettersCustomFilter,
        countQuery: false,
        extractor: (response) =>
          response.Me?.Company?.businessPost?.letter?.data,
        customGridOptions: {
          getContextMenuItems: (params) => {
            return ['copy']
          },
          components: {},
          processCellForClipboard: valueGetter,
          defaultCsvExportParams: {
            processCellCallback: valueGetter,
          },
        },
        customVariables: { letterId: letterId },
      }
    },
    [letterId, t]
  )
  return { getParams }
}
